export enum EventNames {
  CLICK = 'click',
  MOUSE_DOWN = 'mousedown',
}
